// extracted by mini-css-extract-plugin
module.exports =  {"features-list":"_7506d987b5--features-list--Lg1vB","two-lines":"_7506d987b5--two-lines--scB62","feature-title":"_7506d987b5--feature-title--hQOu9"};